// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1klcF","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__gS3kp"};